<template>
  <mp-box :class="modifyClass" :w="isFullWidth ? '100% !important' : 'auto'">
    <mp-input-group my="1" rounded="md">
      <mp-input-left-addon :with-background="false">
        <mp-icon name="search" size="sm" />
      </mp-input-left-addon>
      <mp-input
        v-model="keyword"
        :placeholder="placeholder"
        :is-disabled="isLoading"
        pr="7"
        data-qa="search-input"
        @input="onChangeFilterHeader"
        @keyup="$emit('keyup', $event)"
      />
      <mp-input-right-addon v-if="keyword" :with-background="false">
        <mp-icon name="close" size="sm" cursor="pointer" data-qa="search-reset" @click.native="resetSearch($event)" />
      </mp-input-right-addon>
    </mp-input-group>
  </mp-box>
</template>
<script>
import { debounce } from 'lodash-es';

export default {
  name: 'InputSearch',
  props: {
    search: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Search employee name',
    },
    modifyClass: {
      type: String,
      default: 'tl-filter__item tl-filter__item-search',
    },
    isFullWidth: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keyword: this.search || '',
    };
  },
  watch: {
    search(val) {
      this.keyword = val;
    },
  },
  methods: {
    resetSearch(event) {
      if (!this.isLoading) {
        this.keyword = '';
        this.$emit('input', '');
        this.$emit('reset', event);
      }
    },
    onChangeFilterHeader: debounce(function() {
      this.$emit('input', this.keyword);
    }, 1000),
  },
};
</script>
